module.exports = __webpack_public_path__ + "static/How-to-Install-1-e1403552583616-1103ef85fedb77dab58845fa769cd355.jpg";